import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CustomDatePipe } from 'src/app/_pipes/custom-date.pipe';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { BusinessTransportMetadataComponentAbstract } from '../../../metadata-components/business-metadatas/business-transport-metadata/business-transport-metadata.component.abstract';

@Component({
  selector: 'app-business-transport-metadata-v2',
  standalone: true,
  imports: [CommonModule, CardComponent, CustomDatePipe],
  templateUrl: './business-transport-metadata-v2.component.html',
})
export class BusinessTransportMetadataV2Component extends BusinessTransportMetadataComponentAbstract {}
